import { render, staticRenderFns } from "./TCLAHubSpoke.vue?vue&type=template&id=f636b106&scoped=true"
import script from "./TCLAHubSpoke.vue?vue&type=script&lang=js"
export * from "./TCLAHubSpoke.vue?vue&type=script&lang=js"
import style0 from "./TCLAHubSpoke.vue?vue&type=style&index=0&id=f636b106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f636b106",
  null
  
)

export default component.exports